import { PageError } from '../extensions/PageError';
import { InvoiceDTO } from '../models/InvoiceDTO';
import { OAuthApiClient } from './OAuthApiClient';

export class BillingApi {
    private publicOAuthApiClient: OAuthApiClient;
    constructor(oAuthApiClient: OAuthApiClient) {
      this.publicOAuthApiClient = oAuthApiClient;
    }
  
    public GetInvoice = async (invoiceId: string, authNumber: string): Promise<InvoiceDTO> => {

      const headers = { 'X-ZEN-Authorisation-Code': authNumber };

      let invoice = await this.publicOAuthApiClient.Get<InvoiceDTO>(
            `/billing/invoices/${invoiceId}`, headers
      );

      if (!invoice)
        throw new PageError('Failed to load invoice', { invoiceId, authNumber });

      invoice.isGuest = invoice.isGuest || !invoice.items.length;

      return invoice;
    };
  }